import { Check } from './Check';
import { FavoriteButton } from './FavoriteButton';
import { HeaderLogo } from './HeaderLogo';
import { LogoutBase } from './LogoutBase';
import { MainMenuLinksGrid } from './MainMenuLinksGrid';

export const components = {
  Check,
  FavoriteButton,
  HeaderLogo,
  LogoutBase,
  MainMenuLinksGrid,
};
